
import { Search } from 'vant'
import { getTime, transform } from '../../../assets/js/xjpublic';
import { errorModal } from '../../../assets/js/xjcommon';
// 方法一，加载顺序有问题
// import AMap from 'AMap' // 引入高德地图
// 方法二
import {AMap} from '../../../assets/libs/loadjs';

export default {
  name: 'home',
  components: {
    [Search.name]: Search
  },
  data () {
    return {
      mapCenter: [104.065755, 30.657555],
      mapZoom: 16,
      mapIcon: require('../../../assets/images/map/ic_redcar.png'),
      mapAngle: 0,
      devImei: '',
      parkingAddress: '加载中...',
      parkingTime: '',
      taskID: '',
      mediaType: 2,
      _id:"",
      location:"",
      // 检查显示地址的节点是否加载
      checkAddressTextTimes: 0,
      setIntervalCheckAddressText: null
    }
  },
  methods: {
    // 初始化地图,showType参数为init只加载一个默认地图,不加载图标和窗口
    initMap () {
      this.$axios.post('/v3/u/park/detail', {
        limit: this.onePageNumber,
        page: this.nowPage,
        taskId:this.taskID
      }).then(res=>{
        // 9:图片,10:视频
        const resource =res.data.data.find(item=> [9,10].includes(item.type));
        const mapGps = resource.pos.length ? resource.pos : this.mapCenter
      let map = new AMap.Map('mapParking', {
        center: mapGps,
        resizeEnable: true,
        zoom: this.mapZoom
      });
      this.mediaType = resource.type;
      this._id = resource._id;
      // 创建一个 Marker 实例：
      let marker = new AMap.Marker({
        position: mapGps,   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title: '',
        offset: new AMap.Pixel(-17, -30),
        icon: this.mapIcon, // 图标不能通过相对路径直接引入,可以通过require()引入或者使用网络url
        angle: this.mapAngle
      });
      // 将创建的点标记添加到已有的地图实例：
      map.add(marker);
      // 折线的节点坐标数组，每个元素为 AMap.LngLat 对象
      let title = '<span style="color: #007aff;">停车信息</span>';
      let content = [
        `<div style="background-color: #ffffff;padding-top: 5px;border-radius: 5px;color: #333333;">
        <p style="padding: 5px 0;  ">停车地址：<span id="address-text" class="${resource.location?'df':'fd'}"  onclick="transformHandle()">${resource.location||"点击查看详细地址"}</span><span id="dev-accuracy"></span></p>
        <p style="padding: 1px 0;">停车时间：${(getTime.getFormatDate(2, resource.trigger_time) || '')}</p>
        </div>`
      ];
      // 实现自定义窗体内容，返回拼接后的字符串
      function createInfoWindow (title, content) {
        // 内容拼接 ...
        return title + content;
      }

      // 创建 infoWindow 实例
      let infoWindow = new AMap.InfoWindow({
        isCustom: false,  // 是否使用自定义窗体
        anchor: 'bottom-center', // 默认值：'bottom-center'
        content: createInfoWindow(title, content.join('<br>')),  // 传入dom对象，或者html字符串
        offset: new AMap.Pixel(0, -30), // 信息窗体显示位置偏移量
        closeWhenClickMap: true, // 是否在鼠标点击地图后关闭信息窗体，默认false
        showShadow: false, // 是否显示信息窗体阴影默认值：false
        // size: ''
      });
      // 信息窗体打开
      infoWindow.open(map, mapGps);
      // 信息窗体关闭
      // infoWindow.close();

      // 监听地图的点击事件
      AMap.event.addListener(map, 'click', function () {
        infoWindow.open(map, mapGps);
      });
      // 监听点标记的点击事件
      AMap.event.addListener(marker, 'click', function () {
        infoWindow.open(map, mapGps);
      });

      // 解析地址
      // let _this = this;
      // transform.pointToAddress(_this.mapCenter[0], _this.mapCenter[1], 1, function (res) {
        // console.log(res);
        // if (res.code === 0) {
        //   // 根据坐标点解析出地址信息后显示到页面
        //   let addressText = document.querySelector('#address-text');
        //   addressText.innerHTML = res.address;
        //   _this.parkingAddress = res.address;
        // } else {
        //   let addressText = document.querySelector('#address-text');
        //   addressText.innerHTML = '未上传地址信息';
        //   _this.parkingAddress = '未上传地址信息';
        // }
        // _this.checkAddressTextFn(res);
      // });
    })
    },
    // 判断显示地址信息的节点是否加载
    checkAddressTextFn (res) {
      let addressTextNode = document.querySelector('#address-text');
      if (this.checkAddressTextTimes < 10) {
        if (addressTextNode) {
          clearInterval(this.setIntervalCheckAddressText);
          this.showAddressFn(res);
        } else {
          let _this = this;
          let setIntervalCheckAddressText = setInterval(function () {
            _this.checkAddressTextTimes++;
            _this.checkAddressTextFn(res);
          }, 1000);
          this.setIntervalCheckAddressText = setIntervalCheckAddressText;
        }
      } else {
        clearInterval(this.setIntervalCheckAddressText);
        this.showAddressFn(res);
      }
    },
    // 将解析出的地址信息显示到页面(用定时器是因为偶尔会出现document.querySelector('#address-text')为null的情况,引起报错)
    showAddressFn (res) {
      if (res.code === 0) {
        // 根据坐标点解析出地址信息后显示到页面
        let addressText = document.querySelector('#address-text');
        addressText.innerHTML = res.address;
        this.parkingAddress = res.address;
      } else {
        let addressText = document.querySelector('#address-text');
        addressText.innerHTML = '未上传地址信息';
        this.parkingAddress = '未上传地址信息';
      }
    },
    // InfoWindow弹框
    infoWindowClose () {
      this.showInfoWindow = false;
    },
    infoWindowOpen () {
      this.showInfoWindow = true;
    },
    // 查看停车照片/视频
    toShowMediaPageFn () {
      this.$router.push('/showMedia?task_id=' + this.taskID)
    }
  },
  mounted () {
    // 获取页面传参
    // 坐标
    let lon = this.$route.query.lon;
    let lat = this.$route.query.lat;
    let time = this.$route.query.time;
    let taskID = this.$route.query.task_id;
    let mediaType = this.$route.query.type;
    this.parkingTime = time;
    this.taskID = taskID;
    this.mediaType = parseInt(mediaType);
    // 地图不能在 created 阶段调用，会找不到 html 元素 div#mapParking
    document.getElementById('mapParking').style.height = window.screen.height;
    this.initMap();
    window.transformHandle = () => {
        const id = this._id;
        const type = this.mediaType;
        transform.regeoAddress(id,type, (res)=>{
          if (res.code === 0) {
            let addressText = document.querySelector('#address-text');
                addressText.innerHTML = "res.address";
          }
        });
    }
  }
}
